export default {
    "advanced": {
        "rangeSeparator": " / ",
        "dateRangePicker": {
            "separator": " / ",
            "from": "From",
            "to": "To"
        },
        "rangeInput": {
            "separator": "/"
        },
        "select": {
            "nItems": "{count} items selected",
            "allItems": "All items selected",
            "noItems": "No items selected"
        }
    }
};
